import React from 'react';
import { useUrlBuilder } from 'hooks/useUrlBuilder';
import { LazyImgDpr } from '../../LazyImgDpr/LazyImgDpr';
import { TextContainer } from './common';
import { ordersAndShipping, returnsPolicy } from '../../../helpers/routes';

export const Shipping: React.FC<{}> = () => {
  const { localized } = useUrlBuilder();
  return (
    <>
      <TextContainer>
        We offer free express international shipping on every order to ensure your pieces arrive quickly and safely.
        Learn more about our{' '}
        <a href={localized(ordersAndShipping)} style={{ fontSize: '15px', textDecoration: 'underline' }}>
          shipping process
        </a>{' '}
        and{' '}
        <a href={localized(returnsPolicy)} style={{ fontSize: '15px', textDecoration: 'underline' }}>
          returns policy
        </a>
        .
      </TextContainer>
      <LazyImgDpr
        className="icon"
        srcDpr1="https://cdn-images.italist.com/image/upload/c_scale,h_40,q_auto:best/v1583940670/icons/dhl-exact.png"
        srcDpr2="https://cdn-images.italist.com/image/upload/c_scale,h_40,dpr_2,q_auto:best/v1583940670/icons/dhl-exact.png"
        width="143px"
      />
      <style jsx>{`
        .icon {
          display: block;
          margin-left: auto;
          margin-right: auto;
          height: 37px;
        }
      `}</style>
    </>
  );
};
